<template>
  <b-container fluid>
    <div class="horizontal-menu">
      <b-row>
        <b-col>
          <h2>Account</h2>
        </b-col>
        <b-col class="float-right">
          <b-button variant="primary" class="float-right ml-2" @click="logout">Logout</b-button>
        </b-col>
      </b-row>
      <b-nav>
        <b-nav-item :to="{name: 'site_edit'}" exact exact-active-class="tab_active">Site</b-nav-item>
        <b-nav-item :to="{name: 'users'}" exact exact-active-class="tab_active">Users</b-nav-item>
        <b-nav-item :to="{name: 'billing'}" exact exact-active-class="tab_active">Billing</b-nav-item>
      </b-nav>
    </div>

    <router-view :profile="profile" :user="user" :site="site" />
  </b-container>
</template>

<script>

import {auth} from '@/main.js'

export default {
  name: 'site_links',
  props: ['profile', 'user', 'site'],
  methods: {
    async logout() {
      await auth.signOut()
      this.$router.push({'name': 'home'})
    }
  }
}
</script>

<style scoped>

</style>
